module.exports = __webpack_public_path__ + "img/Bundesliga_2_400x416.df59fab1.jpg";